import Element from '@components/element/Element'
import Column from '@components/layout/Column'
import Row from '@components/layout/Row'
import useMediaQuery, { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled, { useTheme } from 'styled-components'

const BlueTicks = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  &:before {
    content: '';
    position: absolute;
    left: 4px;
    top: 4px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0 0;
    border-color: ${({ theme }) => theme.colors.teal} transparent transparent transparent;
  }
  &:after {
    content: '';
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0 10px 10px;
    border-color: transparent transparent ${({ theme }) => theme.colors.teal} transparent;
  }
`
const ElementShowcaseWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;

  @media (max-width: 820px) {
    display: flex;
    flex-direction: column;
    align-items: center;

    justify-content: center;
    padding: 1rem;
  }
  @media (max-width: 641px) {
    flex-direction: row;

    padding: 1rem;
  }
`

const ElementShowcase = ({
  elements,
  justify = 'flex-end',
  colSize = 'calc(100px + 2rem)',
  iconWidth = '100px',
  iconHeight = '100px',
  marginBottom = 0,
  onClick,
  selected,
}) => {
  const theme = useTheme()
  if (elements?.length > 0) {
    return (
      <ElementShowcaseWrap>
        {elements?.map(({ id, name, icon, slug }) => {
          return (
            <Column
              key={id}
              background={
                selected && selected.length > 0 && selected?.includes(slug)
                  ? theme.colors.grey
                  : theme.colors.darkGrey
              }
              justify="center"
              margin={
                justify === 'flex-end' ? `0 0 ${marginBottom} .5rem` : `0 .5rem ${marginBottom} 0`
              }
              padding="1rem"
              position="relative"
              width={colSize}
              onClick={onClick ? () => onClick(slug) : undefined}
            >
              <BlueTicks />
              <Element
                height={iconHeight}
                icon={icon?.formats?.small?.url}
                name={name}
                thumbnail={icon?.formats?.thumbnail?.url}
                width={iconWidth}
              />
            </Column>
          )
        })}
      </ElementShowcaseWrap>
    )
  }
  return null
}

export default ElementShowcase
